// extracted by mini-css-extract-plugin
module.exports = {"Main":"SectionHeaderSelector_Main__1WEZc","Icon":"SectionHeaderSelector_Icon__3pO0v","Label":"SectionHeaderSelector_Label__175aK"};